"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.IconNamePropType = void 0;

var _classnames = _interopRequireDefault(require("classnames"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireDefault(require("react"));

var _iconChildren = require("./icon-children");

var _excluded = ["name", "size", "filled", "className"];

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var Icon = /*#__PURE__*/_react["default"].forwardRef(function (props, ref) {
  var name = props.name,
      size = props.size,
      filled = props.filled,
      className = props.className,
      otherProps = _objectWithoutProperties(props, _excluded);

  var classes = (0, _classnames["default"])(className, "feather", "feather-".concat(name), {
    "pds-icon-filled": filled
  });
  return /*#__PURE__*/_react["default"].createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: classes,
    "data-size": size,
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: "1.5",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    "aria-hidden": "true",
    focusable: "false",
    ref: ref
  }, otherProps), _iconChildren.iconChildren[name]);
});

var IconNamePropType = _propTypes["default"].oneOf(Object.keys(_iconChildren.iconChildren));

exports.IconNamePropType = IconNamePropType;
Icon.propTypes = {
  /**
   * The name of the icon, which is used to determine which icon to render.
   * [See full list of icons](https://design.principal.com/development/foundation/icons#icons)
   */
  name: IconNamePropType.isRequired,

  /** The font-size of the icon in "px" */
  size: _propTypes["default"].oneOf([12, 16, 20, 24, 32, 40, 60]),

  /** Whether or not the icon is filled. */
  filled: _propTypes["default"].bool,

  /** Extra classes for the Icon. */
  className: _propTypes["default"].string
};
Icon.displayName = "Icon";
Icon.defaultProps = {
  size: 24,
  filled: false
};
var _default = Icon;
exports["default"] = _default;